"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";

const userStore = new Collection({keyNames: ["_id"]});
export default userStore;

window.userStore = userStore;

dispatcher.on('getUsers', users => userStore.set(users));
dispatcher.on('updateUser', user => userStore.update(user._id, user));
dispatcher.on('logout', () => userStore.set(null));


// WEBPACK FOOTER //
// ./src/store/users.js